var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastrouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8828 10.4098L28.0164 16.8684V13.3842H20.2592L17.7616 17.6895C17.6127 17.9132 17.6127 18.2116 17.7243 18.4353C17.8733 18.6591 18.0966 18.8083 18.3944 18.8083H26.6951L15.491 36L17.6499 25.7073C17.6871 25.4836 17.6499 25.2598 17.501 25.0733C17.3521 24.8869 17.1288 24.8123 16.9055 24.8123H8.19531L14.1496 7.42506H18.3261V7.41479L28.0164 7.42506V4L31.8828 10.4098Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastrouter);
export default __webpack_public_path__ + "static/media/fastrouter.285108cc917330d21fc423e9b561ac36.svg";
export { ForwardRef as ReactComponent };